import 'bootstrap/dist/css/bootstrap.css';
import "./index.css";
import "react-router-bootstrap";
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { App } from './app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { store } from './lib/store';
import { Provider } from 'react-redux';
import { SignalRProvider } from './context/SignalRContext';
import { DownloadsGlobalNotification } from './components/ui/DownloadsGlobalNotification';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') || undefined;
const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
  <SignalRProvider>
  <BrowserRouter basename={baseUrl}>
    {/* <AuthProvider> */}
    <Provider store={store}>
      <Routes>
        <Route path="/*" element={<App />}/>
      </Routes>
      <DownloadsGlobalNotification />
    </Provider>
    {/* </AuthProvider> */}
  </BrowserRouter>
  </SignalRProvider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
